export const ARCHIVE_COLLECTION_NAME = "_archive"
export const TOKEN_KEY = "token"
export const TOKEN_REFRESH_KEY = "refreshToken"
export const LOCALE_KEY = "locale"
export const AGENT_NAME = "Wilson"
export const AGENT_ROLE = "Logistics Coordinator"
export const COMPANY_NAME = "Cartage"
export const COMPANY_PUBLIC_URL = "https://cartage.ai/"
export const PRODUCTION_APP_URL = "https://wilson.cartage.ai"
export const ONBOARDING_DOC_NAME_PREFIX = "Workflow Setup"
export const ONBOARDING_PLACEHOLDER_MARKER = "[To be documented]"
